module.exports = __webpack_public_path__ + "static/media/5.204f5029.png";